import script from "./questions-common.vue?vue&type=script&setup=true&lang=js"
export * from "./questions-common.vue?vue&type=script&setup=true&lang=js"

import "./questions-common.vue?vue&type=style&index=0&id=d618fa66&lang=less"

const __exports__ = script;

export default __exports__